module.exports = __webpack_public_path__ + "static/media/marque-parcours.d857fec5.glb";